//Quick View
$(document).ready(function () {
  $.getScript("https://cdn.shopify.com/s/files/1/0940/8252/files/jquery.fancybox.min.js").done(function() {
    quickView();
  });
 });
  

 function quickView() {
  $(".quick-view").click(function () {
    var description =$(this).parent().parent().find(".quickViewDescription").html()
    if ($('#quick-view').length == 0){$("body").append('<div id="quick-view"></div>');}
    var product_handle = $(this).data('handle');
    $('#quick-view').addClass(product_handle);
    jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
      $('og-offer').attr("product",product.variants[0].id);
     optionsToHide=$('.optionsToHide').val()
     console.log(optionsToHide)
     optionsToHide=JSON.parse(optionsToHide)
     var obj = optionsToHide.find(o => o.variantid == product.variants[0].id);
      var title = product.title;
      if(product.variants.length>1){
        window.variant_id=optionsToHide.find(o => o.variantid == product.variants[0].id) != undefined?product.variants[0].id:product.variants[1].id;
        window.regular_price=optionsToHide.find(o => o.variantid == product.variants[0].id) != undefined?product.variants[0].price:product.variants[1].price;
        window.compare_at_price=optionsToHide.find(o => o.variantid == product.variants[0].id) != undefined?product.variants[0].compare_at_price:product.variants[1].compare_at_price;
      }else{
        window.variant_id=product.variants[0].id;
        window.regular_price=product.variants[0].price;
        window.compare_at_price=product.variants[0].compare_at_price;
      }
     
      window.global_product=product;
      var type = product.type;
      var images = product.images;
      var url = '/products/' + product_handle;
     
      var dataDropDown=$('.dataDropDown').val(); 
      for (variant of product.variants){
        try {
          window.savePrice=Number(variant.selling_plan_allocations[0].price/100);
        } catch (error) {
          window.savePrice=0;
        }
        
      }  
      $('.DescriptionContainer').html(description)   
      var saves=JSON.parse(dataDropDown);
      $('.productPrice').val(product.price)
      $('.productPriceCompare').val(product.compare_at_price)
      dropItems=false     
      for(save of saves){
          for(tag of product.tags){
             if(tag===save.tag){ 
              dropItems=save.dropitems
              $('.custom-select').find("select").find('option').eq(0).html(dropItems[0].label);
              $('.custom-select').find("select").find('option').eq(0).val(dropItems[0].value);
              break;
             } 
          }
         
      }
     
      if(dropItems ){
        var i=0;
        $('.select-selected').html(dropItems[0].label)
        for(dropItem of dropItems){
          $('.select-items').find('div').eq(i).html(dropItem.label);
          $('.custom-select').find("select").find('option').eq(i+1).html(dropItem.label);
          $('.custom-select').find("select").find('option').eq(i+1).val(dropItem.value);
        i=i+1;
        }
      }else{
        $('.custom-select').remove()
        $('[name="quantity"]').attr('name',"quantityHidden");
      }

        if(product.variants.length>1) {
          var tv1=optionsToHide.find(o => o.variantid == product.variants[0].id);
          if(tv1 !=undefined){tv1=" ";}else{tv1= product.variants[0].title;}
          var tv2=optionsToHide.find(o => o.variantid == product.variants[1].id);
          if(tv2 !=undefined){tv2=" ";}else{tv2= product.variants[1].title;}
          $('.switcherLeft').html(tv1)
          $('.switcherLeft').attr("value",product.variants[0].id)
          $('.switcherRight').html(tv2)
          $('.switcherRight').attr("value",product.variants[1].id)
          for (variant of product.variants){
           t=optionsToHide.find(o => o.variantid == variant.id);
           if( t!=undefined){
            $('.switch').html('')
            $('.custom-select').css({marginTop:"36px"})
           }
          }

         }else
         {
            $('.switch').remove();
         }

      $('[name="quantity"]').attr("value","1");
      $('[name="id"]').val(product.variants[0].id);
      $('[name="id"]').attr("data-productid",product.id);
      $('[name="id"]').attr("data-compare_at_price",product.variants[0].compare_at_price);
      $('[name="id"]').attr("data-price",product.variants[0].price);
      $('.qv-product-title').text(title);
      $('.qv-product-type').text(type);
      $('.view-product').attr('href', url);
      $(".current_price").html("$"+Number(product.price/100).toFixed(2))
      if(product.compare_at_price){
          $(".was_price").html("$"+Number(product.compare_at_price/100).toFixed(2))
          $('.percent_saved').html(Number((product.compare_at_price-product.price)*100/product.compare_at_price).toFixed(2));
      }else
      {
          $('#testSavePercent').remove()
      }
      var carousel_container= $("<div class='carousel-container'><ul class='carousel product-carousel'></ul></div>");
      $(product.media).each(function (i, image) {
        if(image.media_type=="image"){
        var df=""
        if(i==0)
        df="default_slide";
        var IDV=product.variants[0].id;
       if(product.variants.length>1){
        var ALT=""+image.alt+"";
        
        if(ALT.includes(""+product.variants[0].title)){
           IDV=product.variants[0].id;
        }
        if(ALT.includes(""+product.variants[1].title)){
          IDV=product.variants[1].id;
        }
      }
        item=$('<li data-full="'+image.src+'" data-variant="'+IDV+'"  data-default="'+IDV+'" class="variant_slide size-11 slick-slide slick-current slick-active '+df+'" ><img src="'+image.src+'"  sizes="(min-width: 1600px) 960px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)" loading="lazy" width="100%" height="100%" alt="q_1 main-product-image"></li>');
          carousel_container.find('ul').append(item)
          }
       });

      var carousel_nav=$('<div class="carousel-nav carousel-nav--vertical"><ul class="carousel-nav-list"></ul></div>');
          $(product.images).each(function (i, image) {
           // if(image.media_type =="image"){
            var df=""
            if(i==0)
            df="active";
            item=$('<li class="carousel-nav-item '+df+'" data-slide="'+i+'"><img src="'+image+'"  sizes="(min-width: 1600px) 960px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)" loading="lazy" width="100%" height="100%" alt="q_1 main-product-image"></li>');
            carousel_nav.find('ul').append(item)
            //}
          });
          $('<span class="carousel-btn prev-img nav-btn"><i class="fa fa-1-5x fa-chevron-up" aria-hidden="true"></i></span>').insertBefore(carousel_nav.find('ul'))
          $('<span class="carousel-btn next-img nav-btn"><i class="fa fa-1-5x fa-chevron-down" aria-hidden="true"></i></span>').insertAfter(carousel_nav.find('ul'))
      
    
      $('.qv-product-images').append(carousel_container);
      $('.qv-product-images').find('.carousel-container').append(carousel_nav)
      window.product =product;
      var head= document.getElementsByTagName('head')[0];
      var script1= document.createElement('script');
      script1.src= $('.DropDonwScript').val();
      

      script= document.createElement('script');
      script.src= $('.carouselScript').val();
       setTimeout(function(){head.appendChild(script1); head.appendChild(script);},1500);
      qty=1;

      $('.switcherType').click(function(){
        if($('.switcherLeft').hasClass('Grayed')){
           $('.switcherRight').addClass('Grayed') 
           $('.switcherLeft').removeClass('Grayed')
           $('[name="id"]').val($('.switcherLeft').attr("value"))
           window.variant_id=product.variants[0].id
           window.regular_price=product.variants[0].price
           window.compare_at_price=product.variants[0].compare_at_price
         }else{
           $('.switcherLeft').addClass('Grayed')
           $('.switcherRight').removeClass('Grayed')
           $('[name="id"]').val($('.switcherRight').attr("value"))
           window.variant_id=product.variants[1].id
           window.regular_price=product.variants[1].price
           window.compare_at_price=product.variants[1].compare_at_price
         }
         quantityVariantImage();
      }); 


    });
    wd="75%";
    hg="60%";
    coc=false
  if(screen.width<900){

wd="92%";
hg="65%";
  }
    $.fancybox({
      href: '#quick-view',
      maxWidth: 900,
      maxHeight: 400,
      width: wd,
      height: hg,
      autoSize: false,
      closeClick: coc,
      openEffect: 'none',
      closeEffect: 'none',
      closeBtn: true,
      hideOnContentClick: false,
      'onComplete': function() {
        $("#fancybox-wrap").css({'top':'20%', 'bottom':'auto'});
      },
      'beforeLoad': function () {
          $('#quick-view').html("");
        var product_handle = $('#quick-view').attr('class');

      
  


        $('.fancybox-wrap').css('overflow', 'hidden !important');
      },
      'afterShow': function () {
        $('#quick-view').hide().html(content).css('opacity', '1').fadeIn(function () {
          $('.qv-product-images').addClass('loaded');
        });
      },
      'afterClose': function () {
        $('#quick-view').removeClass().empty();
      }
    });
  });
 };


 function SubScrib_addToCart ( ) { 
  var comp=$('[name="id"]').attr('data-compare_at_price') 
CartJS.addItem($('[name="id"]').val(), 1, {"selling_plan": 2890793146,"_compare_at_price":comp},{
"success": function(data, textStatus, jqXHR) {
    $.openCartDrawer();
} 
});
 }

 function regular_addToCart(){
  var comp=$('[name="id"]').attr('data-compare_at_price') 
  var  qt=$('[name="quantity"]').val() || 1;
  if (Number(window.compare_at_price)==0)
   qt=1;
    CartJS.addItem( $('[name="id"]').val(), qt,{"_compare_at_price":comp}, {
    "success": function(data, textStatus, jqXHR) {
        $.openCartDrawer();
    } 
});  
}

$(document).on("click", "#QvAddToCart", function () {
          
  if($('og-when').find('og-optout-button').attr("subscribed")!=undefined){
       SubScrib_addToCart();
  }else{
      regular_addToCart();
  }
    


});

function quantityVariantImage(){
  var product = window.global_product;
  if(!product)
  return;

  if(product.variants.length>1){ 
      var v = [];
      var vr1 = product.variants[0].id;
      var vr2 = product.variants[1].id;
      v[vr1] = [];
      v[vr2] = [];
      v[vr1].push({quantity:1,src:product.variants[0].featured_image.src})
      v[vr2].push({quantity:1,src:product.variants[1].featured_image.src})
     for (image of product.media){
      vr1=product.variants[0].id; 
      vr2=product.variants[1].id; 
      var ALT=""+image.alt+"";
       if (ALT.includes("quantity") && image.alt!=null){
          if (ALT.includes(" 3")){ 
            if (ALT.includes(product.variants[0].title)) {
              v[vr1].push({quantity:3,src:image.src}); 
              console.log(ALT.includes(""+product.variants[0].title))
            }
            if (ALT.includes(product.variants[1].title)) {
              v[vr2].push({quantity:3,src:image.src});
              console.log(ALT.includes(""+product.variants[0].title))
            }

          }

          if (ALT.includes(" 2")){ 
            if (ALT.includes(product.variants[0].title)) {
              v[vr1].push({quantity:2,src:image.src}); 
              console.log(ALT.includes(""+product.variants[0].title))
            }
            if (ALT.includes(product.variants[1].title)) {
              v[vr2].push({quantity:2,src:image.src});
              console.log(ALT.includes(""+product.variants[0].title))
            }

          }

          if(ALT.includes(" 6")){
            if (ALT.includes(product.variants[0].title)) {
              v[vr1].push({quantity:6,src:image.src}); 
              console.log(ALT.includes(""+product.variants[0].title))
            }
            if (ALT.includes(""+product.variants[1].title)) {
              v[vr2].push({quantity:6,src:image.src});
              console.log(ALT.includes(""+product.variants[0].title))
            }
          
          }
      }
    }
    }else{
      console.log("hghg")
      var v = [];
      var vr1 = product.variants[0].id;
      v[vr1] = [];
      v[vr1].push({quantity:1,src:product.featured_image})
     for (image of product.media){
      vr1=product.variants[0].id; 
      var ALT=""+image.alt+"";
       if (ALT.includes("quantity") && image.alt!=null){
          if (ALT.includes(" 3")){ 
            if (ALT.includes(""+product.variants[0].title) || ALT.includes("default")) {
              v[vr1].push({quantity:3,src:image.src}); 
              console.log(ALT.includes(""+product.variants[0].title))
            }
          }
          if (ALT.includes(" 2")){ 
            if (ALT.includes(""+product.variants[0].title) || ALT.includes("default")) {
              v[vr1].push({quantity:2,src:image.src}); 
              console.log(ALT.includes(""+product.variants[0].title))
            }
          }
          if(ALT.includes(" 6")){
            if (ALT.includes(""+product.variants[0].title) || ALT.includes("default") ) {
              v[vr1].push({quantity:6,src:image.src}); 
              console.log(ALT.includes(""+product.variants[0].title))
            }
          }
      }

    }
    console.log(v)
  }
   if($(".variant_slide[data-variant]").length !== 0){
    var variantImageId = window.variant_id;
    var slideImage  = $(".variant_slide[data-variant='" + variantImageId + "']");
    console.log("64554564"+slideImage.html())
    var quant = $('[name="quantity"]').val();
    var arr = v[variantImageId];

    var obj = arr.find(o => o.quantity == quant);
    console.log(obj.src)
    if(obj != undefined){ 
      slideImage.data("full",obj.src+"&width=1024");
      slideImage.find("img").attr("src",obj.src+"&width=1024");
      $('.slick-active').find('img').attr("src",obj.src+"&width=1024")
      $(".carousel-nav-item.active").find("img").attr("src",obj.src+"&width=150");
      
    }
   }  
  

}


//setInterval(quantityVariantImage, 5000);

